module.exports = __webpack_public_path__ + "static/media/nat1.eced9bd7.webp";